<template lang="html">
  <div class="sub-main column">
		<div class="sub-page column">
			  <section class="take-place column activity-container container-background">
					<div class='header-table row'>
						<div class='title'>
							Cabinets
						</div>
						<div class="attached-item row">
							<div class="phantom-flex"></div>
							<div class="ctn-cta">
								<div class="btn btn-red" @click="showNewCabinet">
									<span class="icon-form-plus"></span> Ajouter un cabinet
								</div>
							</div>
						</div>
					</div>
					<Table
						:elements="cabinets"
						:clickable="false"
						@statuschange="updateStatus"
						@editCabinet="editCabinet"
					/>
					<baseModal
						:show="showAddCabinet"
						@close="showAddCabinet = false"
						:content="contentModal"
						:data="{currentCabinet: currentCabinet}"
						:disableClickOutside="true"/>
  			</section>
		</div>
  </div>
</template>

<style lang="scss">
</style>

<script>
import store from '@/store'
import {mapGetters} from 'vuex'
import ModalAddCabinet from './modals/CabinetModal'
import baseModal from '@/common/components/baseModal'
import Table from './CabinetsTable'

export default {
	name: 'Cabinets',
	components: {
		Table,
		baseModal
	},
	data () {
		return {
			showAddCabinet: false,
			currentCabinet: null,
			contentModal: ModalAddCabinet
		}
	},
	beforeRouteEnter (to, from, next) {
		store.commit('LOADER_IN')
    store.dispatch('getCabinets')
    // .then(() => new Promise((resolve, reject) => {
    //   resolve();
    // }))
    .then(() => {
      let getClientsPromises = store.getters.cabinets.map((office) => {
        return store.dispatch('getClientsByOfficeId', office.id);
      });
      let getAdvisorsPromises = store.getters.cabinets.map((office) => {
        return store.dispatch('getAdvisorsByOfficeId', office.id);
      });
      let getAdminPromises = store.getters.cabinets.map((office) => {
        return store.dispatch('getAdminByOfficeId', office.id);
      });
      return Promise.all([
        ...getClientsPromises,
        ...getAdvisorsPromises,
        ...getAdminPromises
      ])
    })
    .then(() => {
			next()
    })
    .catch(() => {
			next(false)
    })
    .finally(() => {
			store.commit('LOADER_OUT')
    })
	},
	methods: {
		showNewCabinet () {
			this.currentCabinet = null;
			this.showAddCabinet = true;
		},
		editCabinet (element) {
			const {value, rowIndex} = element
			const cabinet = {...this.cabinets[rowIndex], available: !value}
			console.log(cabinet);
			this.currentCabinet = cabinet;
			this.showAddCabinet = true;
		},
		updateStatus (e) {
			const {value, rowIndex} = e
			const cabinet = {...this.cabinets[rowIndex], available: !value}
			this.$store.dispatch('editCabinet', cabinet)
		}
	},
	computed: {
		...mapGetters({
			cabinets: "cabinets"
		})
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?4bc61b5f